module.exports = __webpack_public_path__ + "static/img/024干部作风大整顿1.c03afcd.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/smPicImgs/024干部作风大整顿1.jpg
// module id = 8Ng9
// module chunks = 0